//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import checker from '@/components/Checker'
import { getStorage, setStorage } from '@/js/utils'
export default {
  name: 'repayRedPacket',
  components: {
    checker
  },
  data() {
    return {
      couponCode: '',
      couponList: [],
      growthCouponVos: [],
      growthCouponVosInfo: {}
    }
  },
  computed: {
    couponTip() {
      let bizContent = {
        invgrowth: "成长权益",
        svip: "会员"
      }
      return bizContent[this.growthCouponVosInfo.bizType] || "";
    }
  },
  methods: {
    selectCoupon(code, amount, couponUsed) {
      this.couponCode = code
      setStorage('session', 'redPacketInfo', { amount, code, couponUsed })
      setTimeout(() => {
        this.$router.go(-1)
      }, 100)
    },
    resumeListenerCallback() {
      try {
        PPDWebUI.ListenerService.removeResumeListener(this.resumeListenerCallback);
      } catch (e) {
        console.log(e);  
      }
      this.$bus.$emit('repay-load', { 'canRepayLoad': true })

      this.$router.go(-1);
    },  
    toReceive(url) {
        const { bizType, batchNo } = this.growthCouponVosInfo;
        this.sendRecord('1073', `${bizType},${batchNo}`);
        PPDWebUI.ListenerService.resumeListener(this.resumeListenerCallback);
        PPDWebUI.CommonService.openUrl(
            { url: url },
            function() {},
            function() {}
        )
    }
  },
  created() {
    const redEnvelopes = getStorage('session', 'redEnvelopes')
    const redPacketInfo = getStorage('session', 'redPacketInfo')
    this.couponCode = redPacketInfo ? redPacketInfo.code : ''

    this.couponUsed = redPacketInfo ? redPacketInfo.couponUsed : ''

    if (redEnvelopes && redEnvelopes.length) {
        this.couponList = redEnvelopes
    }
    // 待领取的优惠券
    const growthCouponVos = getStorage('session', 'growthCouponVos')
    if(growthCouponVos && growthCouponVos.length) {
        this.growthCouponVos = growthCouponVos;
        this.growthCouponVosInfo = growthCouponVos[0];
        const { bizType, batchNo } = this.growthCouponVosInfo;
        this.sendRecord('1072', `${bizType},${batchNo}`);
    }
  }
}
